/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import {
  Button,
  Form,
  InputNumber,
  DatePicker,
  Typography,
  Space,
  Row,
  Col,
} from 'antd';
import styles from '../styles.module.css';

const { Text, Title } = Typography;
function PeriodCard({
  t,
  form,
  selectedOption,
  onOptionChange,
  getValidationRules,
}) {
  const isRange = selectedOption === 'Range';

  return (
    <Row gutter={[14, 16]} className={styles.padding20}>
      {/* Header + Toggle */}
      <Col span={24}>
        <Row justify="space-between" align="middle">
          <div className={styles.headerContent}>
            <Title level={5} className={styles.colorBlack}>
              {t('label_period')}
            </Title>
          </div>

          <Space.Compact>
            <Button
              className={`${styles.toggleButton} ${
                isRange ? styles.activeButton : ''
              }`}
              onClick={() => onOptionChange('period', 'Range')}
            >
              {t('label_pick_days')}
            </Button>

            <Button
              className={`${styles.toggleButton} ${
                !isRange ? styles.activeButton : ''
              }`}
              onClick={() => onOptionChange('period', 'Number')}
            >
              {t('label_total_days')}
            </Button>
          </Space.Compact>
        </Row>
      </Col>

      {/* Fields */}
      <Col span={24} className={styles.marginTop20}>
        {isRange ? (
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Text className={styles.fieldLabel}>
                {t('label_previous_readingDate')}
              </Text>
              <Form.Item
                className={styles.formItemNew}
                name={['period', 'previousReadingDate']}
                dependencies={[['period', 'currentReadingDate']]}
                rules={[
                  ...getValidationRules('previousReadingDate', 'date', null, t),
                ]}
              >
                <DatePicker
                  className={styles.input}
                  placeholder={t('label_select_date')}
                  inputReadOnly={true}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Text className={styles.fieldLabel}>
                {t('label_current_readingDate')}
              </Text>
              <Form.Item
                className={styles.formItemNew}
                name={['period', 'currentReadingDate']}
                dependencies={[['period', 'previousReadingDate']]}
                rules={[
                  ...getValidationRules('currentReadingDate', 'date', null, t),
                ]}
              >
                <DatePicker
                  className={styles.input}
                  placeholder={t('label_select_date')}
                  inputReadOnly={true}
                />
              </Form.Item>
            </Col>
          </Row>
        ) : (
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Text className={styles.fieldLabel}>
                {t('label_number_of_days')}
              </Text>
              <Form.Item
                className={styles.formItemNew}
                name={['period', 'NumOfDays']}
                rules={[
                  { required: true, message: t('label_enter_number_of_days') },
                  {
                    type: 'number',
                    max: 366,
                    message: t('label_maximum_allowed_one_year'),
                  },
                  {
                    type: 'number',
                    min: 1,
                    message: t('label_minimum_allowed_days'),
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  className={styles.width100}
                  placeholder={t('label_enter_numner_of_days')}
                  formatter={(v) =>
                    v ? v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
                  }
                  parser={(v) => v.replace(/,/g, '')}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
}

export default PeriodCard;
